import { EntityListResource } from './entityList.resource';
/**
 * Resource kontenerów na punkty użytkownika
 *
 * @export
 * @class ContainerPointsResource
 * @extends {EntityListResource<ContainerPoints>}
 */
export class ContainerPointsResource extends EntityListResource {
    constructor() {
        super(...arguments);
        this.listFields = {
            id: true,
            points: true,
            spent: true,
            collected: true,
            pointContainer: {
                id: true,
                name: true,
                state: true
            }
        };
        this.listVariables = { filters: 'ContainerPointsFilters' };
    }
}
export const containerPointsResource = new ContainerPointsResource('containerPointsList');
//# sourceMappingURL=containerPoints.resource.js.map